/*----------------------
   ANNONCEMENT BAR
---------------------- */
AnnouncementBar = {
    init: function () {
        var $announcementBar = $(".announcement-bar");

        if (!$announcementBar.length) {
            $("body").removeClass("announcement-bar-active");
            return;
        }

        setTimeout(function () {
            $announcementBar.addClass("active");
            $("body").addClass("announcement-bar-active");
        }, 500);
    }
};

$(document).ready(function () {
    AnnouncementBar.init();
});
